__turbopack_context__.v({
  "container": "AboutThisEventEmbedded-module-scss-module__g-xFlG__container",
  "hidden": "AboutThisEventEmbedded-module-scss-module__g-xFlG__hidden",
});
